import React from 'react';

const SideBarCategory = ({ children }) => {
    return <li className='nav-item nav-category'>{children}</li>;
};

export default SideBarCategory;
